import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '../../assets/config/config-svc.service';
import { HomeService } from '../home/home.service';
import { SharedService } from '../shared/shared.service';
import { CpeTo } from '../shared/models/cpeTo';

@Injectable({
    providedIn: 'root'
})
export class CpeService {

    constructor(public http: HttpClient, public homeService: HomeService, public sharedService: SharedService) {
    }

    getHeaders() {
        return this.getHeadersForContent('application/json', 'json', '');
    }

    getHeadersOrg(org) {
        return this.getHeadersForContent('application/json', 'json', org);
    }

    getHeadersForContent(contentType, responseType, clientId) {
        if (!clientId) {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': contentType,
                    'transactionId': this.sharedService.generateUUID(),
                    'reportType': 'All',
                }),
                withCredentials: true,
                responseType: responseType
            };
            return httpOptions;
        } else {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': contentType,
                    'transactionId': this.sharedService.generateUUID(),
                    'reportType': 'All',
                    'client-id': clientId
                }),
                withCredentials: true,
                responseType: responseType
            };
            return httpOptions;
        }
    }

    public createCpe(payload) {
        return this.http.post(ConfigService.config.brokerServiceUrl + '/cpe',
            payload,
            this.getHeaders()).pipe(map((res: any) => res));
    }

    public updateCpe(cpe: CpeTo) {
        return this.http.put(ConfigService.config.brokerServiceUrl + `/cpe/${cpe.id}`,
            cpe,
            this.getHeaders()).pipe(map((res: any) => res));
    }

    public getCpeList(): Observable<CpeTo[]> {
        return this.http.get<CpeTo[]>(ConfigService.config.brokerServiceUrl + '/cpe?sortActive=&sortDirection=&page=&size=&SEARCH_TERM=',
            this.getHeaders()).pipe(map((res: any) => this.setCpeDataInModel(res)));
    }

    public getCpePage(searchTerm: string, sortActive: string, sortDirection: string,
                      page: number, size: number): Observable<any> {
        return this.http.get<any>(ConfigService.config.brokerServiceUrl + '/cpe?SEARCH_TERM=' + encodeURIComponent(searchTerm ?? '')
            + '&sortActive=' + sortActive + '&sortDirection=' + sortDirection + '&page=' + page + '&size=' + size,
            this.getHeaders()).pipe(map((res: any) => {
                const payload = res?.data ?? res;
                return {
                    content: this.setCpeDataInModel(payload?.content ?? []),
                    totalElements: Number(payload?.totalElements ?? payload?.page?.totalElements ?? 0)
                };
            }));
    }

    public deleteCpe(data: CpeTo): Observable<any> {
        return this.http.delete(ConfigService.config.brokerServiceUrl + `/cpe/${data.id}`,
            this.getHeaders()).pipe(map((res: any) => res));
    }

    setCpeDataInModel(cpeData: any): CpeTo[] {
        const cpeTo = [];
        if (cpeData) {
            if (Array.isArray(cpeData)) {
                cpeData.forEach(element => {
                    if (element) {
                        const eachCpe = new CpeTo(element);
                        cpeTo.push(eachCpe);
                    }
                });
            } else if (typeof cpeData === 'object') {
                cpeTo.push(new CpeTo(cpeData));
            }
        }
        return cpeTo;
    }

    getSharedSecret(cpeName) {
        return this.http.get<any>(ConfigService.config.brokerServiceUrl + `/cpe/secret/${cpeName}`,
            this.getHeadersForContent('text/plain', 'text', '')
        );
    }
}
